import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-login',
  template: require('./login.component.html')
})
export class LoginComponent extends BaseComponent implements OnInit {

  public showForgotPassword = false;

  public msg = "Please login to continue.";
  public redirectUrl = "/admin/home";

  public email = "";
  public passw = "";

  public errorMessage = "";

  ngOnInit() {
    super.ngOnInit();

    if(this.lsApp.isUserLoggedIn()) {
      this.router.navigate([this.redirectUrl]);
    }

  }
// Overloading base component function to get updates on query params
  public queryParamsUpdated() {
    this.msg = this.default(this.currentQueryParams["msg"],"Please login to continue.");
    this.redirectUrl = this.default(this.currentQueryParams["r"],"/admin/home");
    //if(this.redirectUrl)
  }

  public displayForgotPassword() {
    if(this.showForgotPassword) {
      this.showForgotPassword = false;
    }
    else {
      this.showForgotPassword = true;
    }
  }

  public login() {
    var validate:NSValidation = new NSValidation();

        var errorMessage = "";
        if(validate.isEmpty(this.email)) {
            errorMessage = "Please provide your account's email";
        }
        else if (validate.isEmpty(this.passw)) {
            errorMessage = "Please provide your account's password";            
        }

        if(errorMessage!="") {
            bootbox.alert(errorMessage);
        }
        else {
            this.busy = this.lsApi.login(this.email, this.passw).subscribe(resp => {
                if(resp.status) {
                    var user = resp.data[0];
                    localStorage.setItem("user", JSON.stringify(user));
                    this.lsApp.isUserLoggedIn();
                    console.log(this.redirectUrl);
                    this.router.navigate([this.redirectUrl]);
                    //this.router.navigate([this.router.url]);
                }
            },
            error => {
                console.log(error);
            });
        }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/login/login.component.ts